<div class="column">
  <ng-container *ngIf="props?.type === 'BIG'">
    <div class="switch switch-big">
      <span [class.state-off]="value === false"
            [class.state-on]="value === true">{{value ? 'ON' : 'OFF'}}</span>
      <input (ngModelChange)="writeValue($event)"
             [ngModel]="value"
             [id]="_control.name"
             type="checkbox"/>
      <label [for]="_control.name">Toggle</label>
    </div>
  </ng-container>
  <ng-container *ngIf="props?.type === 'REGULAR'">
    <div class="switch">
      <input (ngModelChange)="writeValue($event)"
             [disabled]="disabled"
             [ngModel]="value"
             [id]="_control.name"
             type="checkbox"/>
      <label [for]="_control.name">Toggle</label>
    </div>
  </ng-container>
</div>
